import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import Services from "@/components/Services";
import Destinations from "@/components/Destinations";
import WhereNextMap from "@/components/WhereNextMap";
import Testimonials from "@/components/Testimonials";
import BlogPreview from "@/components/BlogPreview";
import FooterCTA from "@/components/FooterCTA";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#0B1E3F] text-[#F8F9FA]">
      <Header />
      <Hero />
      <TrustStrip />
      <Services />
      <Destinations />
      <WhereNextMap />
      <Testimonials />
      <BlogPreview />
      <FooterCTA />
    </div>
  );
}
